<template>
  <div class="tab-pane fade show active" role="tabpanel">
    <ProductionStrategy
      v-if="companies.length > 0"
      :companies="companies"
      :registry-devices="registryDevices"
    />
    <LoadingIndicatorComponent v-else />
  </div>
</template>

<script setup lang="ts">
import LoadingIndicatorComponent from "@/components/common/LoadingIndicatorComponent.vue";
import ProductionStrategy from "@/dashboard/production_strategy/ProductionStrategy.vue";
import type { Company, RegistryDevice } from "@/types";

defineProps<{
  companies: Array<Company & { id: number }>;
  registryDevices: RegistryDevice[];
}>();
</script>
